import { CoreEvent, eventNames } from '@carvana/core-events';
import { useContext, useEffect } from 'react';
import ModalContext from '~/context/srp/ModalContext';

export default function useToggleModal() {
  const {
    isCoApplicantModalOpen,
    isSoftPullModalOpen,
    setCoApplicantModalOpen,
    setSoftPullModalOpen
  } = useContext(ModalContext);

  useEffect(() => {
    if (isSoftPullModalOpen || isCoApplicantModalOpen) {
      CoreEvent.emit(eventNames.softpullModal.open, {
        isAddCoSigner: isCoApplicantModalOpen
      } as any);
      CoreEvent.once(eventNames.softpullModal.close, () => {
        setSoftPullModalOpen(false);
        setCoApplicantModalOpen(false);
      });
    } else {
      CoreEvent.emit(eventNames.softpullModal.close, {});
    }
  }, [
    isCoApplicantModalOpen,
    isSoftPullModalOpen,
    setCoApplicantModalOpen,
    setSoftPullModalOpen
  ]);
}
